import { atom } from 'jotai'
import type { ArtworkType } from '@/@types/microcms-type'

export const projectAtom = atom<ArtworkType[] | null>(null)

export const initializeProjectAtom = atom(
    null, // get
    (get, set, projects: ArtworkType[]) => {
        const currentProjects = get(projectAtom)
        if (currentProjects === null) {
            set(projectAtom, projects)
        }
    }
)
